import React, { useEffect, useState } from 'react'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import useDebounce from '../../../configurations/commonlib/useDebounce';
import { Link, useParams } from 'react-router-dom';
import { PAGE_SIZE } from '../../../configurations/initUrls';
import Paging from '../../controls/Paging';
import { IoMdOpen } from 'react-icons/io';
import SendEmergencyNow from './SendEmergencyNow';
import { RiEditBoxFill } from 'react-icons/ri';
import StatusContainer from '../../controls/StatusContainer';
import { EOPDConfirmedStatusBg, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import LoadingContainer from '../../controls/LoadingContainer';
import { GetEGenderName } from '../../../configurations/enums/EGender';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import Empty from '../../controls/Empty';

export default function LookOutEmergency({ isActive, searchTerm, isSearch, centerId, forDate }) {

    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [loding, setLoding] = useState(false)
    const [LastPage, setLastPage] = useState(1);
    const [emergencyData, setEmergencyData] = useState([]);
    const [pagingData, setPagingData] = useState();
    const [lodingCrud, setLodingCrud] = useState(false)
    const [isOpenAdd, setIsOpenAdd] = useState(false)
    const [sendData, setSendData] = useState({
        id: 0,
    })

    const [currentPage, setCurrentPage] = useState(1)


    useEffect(() => {
        if (isActive && centerId && forDate) {
            onSearch()
        }
    }, [isSearch, centerId, forDate])

    const OnPageChange = (e) => {
        if (isActive && centerId && forDate) {
            const { value } = e.target;
            setCurrentPage(value)
            GetTodaysEmergency({
                CenterId: centerId,
                PageNo: value,
                PageSize: PAGE_SIZE,
                SearchTerm: searchTerm,
                ForDate: forDate
            })
        }
    }

    const onSearch = () => {
        GetTodaysEmergency({
            CenterId: centerId,
            PageNo: 1,
            PageSize: PAGE_SIZE,
            SearchTerm: searchTerm,
            ForDate: forDate
        })
    }

    const GetTodaysEmergency = (params) => {
        setLoding(true)
        start()
        opdRegisteredCrud.GetForDateEmergency(params).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setEmergencyData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setEmergencyData([])
                // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setEmergencyData([])
            // toast.open(errors, <MdErrorOutline />, "danger")
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const sendEmergencyInCurrentQueue = (param, setValues) => {
        setLodingCrud(true)
        start()
        opdRegisteredCrud.SendEmergencyInCurrentQueue(param).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setValues({
                    id: 0,
                })
                onSearch()
                setIsOpenAdd(false)
                toast.open("Sent in top queue successfully!", <IoCheckmarkCircleOutline />, "success")
            } else {
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
                setIsOpenAdd(false)

            }
            setLodingCrud(false)
            end()
        }).catch(errors => {
            // toast.open(errors, <MdErrorOutline />, "danger")
            setIsOpenAdd(false)
            setLodingCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    return (
        <div class="text-gray-700">
            <div class="text-center text-2xl">
                <div class="px-4 py-2 font-semibold"></div>
                <Paging LastPage={LastPage} CurrentPage={currentPage} OnPageChange={OnPageChange} pagingData={pagingData} >
                    <div className='overflow-x-auto'>
                        <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
                            <thead class="text-xs text-gray-700 uppercase bg-gray-200">
                                <tr>
                                    <th scope="col" class="px-3 py-3">
                                        Ref.No
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Conf./Old
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Name
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Phone
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Age
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Status
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Action
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Address
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {loding ?
                                    <tr class="bg-white border-b hover:bg-gray-100">
                                        <td colSpan={9}>
                                            <LoadingContainer text="Fetching..." />
                                        </td>
                                    </tr>
                                    :
                                    emergencyData.length > 0 ?
                                        emergencyData.map((item, index) =>
                                            <tr class="bg-white border-b hover:bg-gray-100">
                                                <td class="px-3 py-2">
                                                    {item.id}
                                                </td>
                                                <td class="px-3 py-2">
                                                    <span className='font-bold text-green-500'>{item.confirmedAllotedNumber}</span>/ {item.opdNumberAlloted}
                                                </td>
                                                <td class="px-3 py-2 font-bold">
                                                    {item.patientName} <span className='font-normal text-[9px]'>({GetEGenderName(item.gender)})</span>
                                                </td>
                                                <td class="px-3 py-2">
                                                    {item.mobile}
                                                </td>
                                                <td class="px-3 py-2">
                                                    {item.age}
                                                </td>
                                                <td class="px-2 py-2" >
                                                    <div className='mr-2'><StatusContainer bg={EOPDConfirmedStatusBg(item.status)} text={GetEOPDConfirmedStatusName(item.status)} /></div>
                                                </td>
                                                <td class="flex items-center px-2 py-2  sm:w-20">
                                                    {item.status == 0 ?
                                                        <button onClick={() => { setSendData(item); setIsOpenAdd(!isOpenAdd) }} type="button" className="text-sm font-medium text-white bg-sky-500 hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-sky-600 rounded-md px-3 py-1 transition pl-2" title='Confirm'>Confirm</button>
                                                        :
                                                        <StatusContainer bg="bg-green-400" text="Confirmed" />
                                                    }
                                                </td>
                                                <td class="px-3 py-2 text-nowrap">
                                                    {item.patientAddress}
                                                </td>
                                            </tr>
                                        )
                                        :
                                        <tr class="bg-white border-b hover:bg-gray-100">
                                            <td colSpan={8} class="px-3 py-2">
                                                <Empty>
                                                    No Items Found.
                                                </Empty>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </Paging>
                <div class="pb-4"></div>
            </div>
            <SendEmergencyNow SendEmergencyInCurrentQueue={sendEmergencyInCurrentQueue} sendData={sendData} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} />
        </div>
    )
}
